module.exports = "//static.hsappstatic.net/HubspotToolsMenu/static-1.108/css/toolsmenu.css"